<template>
  <div id="app">
    <login/>
  </div>
</template>

<script>
import login from './components/login.vue'
export default {
  name: 'App',
  components: {
    login
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  width: 100vw;
  height: 100vh;
}
</style>
